import {
  ACCESS_LEVELS,
} from '@/lib/consts.js'
import { __t } from '@/lib/helpers.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'

export default {
  path: 'services',
  name: 'settings-services',
  meta: {
    title: __t('routes.settings.services.title'),
    subtitle: __t('routes.settings.services.subtitle'),
    icon: 'services-setup',
    backgroundIcon: 'services',
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
    fullContent: true,
  },
  redirect: { name: 'services.services-and-combos.list' },
  component: () => import('@/views/business/settings/services/index.vue'),
  children: [
    {
      path: '',
      name: 'services.services-and-combos.list',
      meta: {
        title: __t('routes.settings.services.services.title'),
        subtitle: __t('routes.settings.services.services.subtitle'),
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
      },
      component: () => import('@/views/business/settings/services/services-with-addons/index.vue'),
    },
    {
      path: 'service-edit/:serviceId?',
      name: 'services.services-and-combos.service-edit',
      meta: {
        title: __t('routes.settings.services.services.title'),
        subtitle: __t('routes.settings.services.services.subtitle'),
        hintKey: 'hintFeatureSettingsServices',
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
      },
      component: () => import('@/views/business/settings/services/services-and-combos/services/edit.vue'),
    },
    {
      path: 'combo-edit/:comboId?',
      name: 'services.services-and-combos.combo-edit',
      meta: {
        title: __t('routes.settings.services.combos.title'),
        subtitle: __t('routes.settings.services.combos.subtitle'),
        hintKey: 'hintFeatureServiceCombos',
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
      },
      component: () => import('@/views/business/settings/services/services-and-combos/combos/edit.vue'),
    },
    {
      path: 'assign-service-type',
      name: 'services.services-and-combos.assign-service-type',
      meta: {
        title: __t('routes.settings.services.assign-service-type.title'),
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: (store) => {
          return store.state.routingConfig.config.service_type_feature
        },
      },
      component: () => import('@/views/business/settings/services/services-and-combos/assign-service-type/index.vue'),
    },
    {
      path: 'add-ons',
      name: 'services.add-ons',
      meta: {
        title: __t('routes.settings.services.add-ons.title'),
        subtitle: __t('routes.settings.services.add-ons.subtitle'),
        hintKey: 'hintFeatureAddOns',
      },
      component: () => import('@/views/business/settings/services/services-with-addons/index.vue'),
    },
    {
      path: 'add-ons/edit/:id?',
      name: 'services.add-ons.edit',
      meta: {},
      component: () => import('@/views/business/settings/services/add-ons/edit.vue'),
    },
  ],
}
